import { render, staticRenderFns } from "./HRdetails.vue?vue&type=template&id=71bad0cf"
import script from "./HRdetails.vue?vue&type=script&lang=js"
export * from "./HRdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports